module.exports = __webpack_public_path__ + "img/applySharer_fail.07c19d6e.png";